import React, { useState, useEffect, useContext } from "react";
import { Container, Alert, Tabs, Tab, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AuthContext from "../contexts/AuthContext";
import DataTable from "./DataTable";
import AdminDashboard from "./AdminDashboard";

const AdminDataView = () => {
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("dashboard");

  // Check if user is an admin
  const isAdmin = auth.user?.is_staff || auth.user?.is_superuser;

  useEffect(() => {
    if (!isAdmin) {
      // Redirect if not admin
      navigate("/");
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) {
    return (
      <Container>
        <Alert variant="danger" className="mt-4">
          <Alert.Heading>Access Denied</Alert.Heading>
          <p>
            You do not have permission to view this page. This page is
            restricted to admin users only.
          </p>
        </Alert>
      </Container>
    );
  }

  return (
    <Container fluid>
      <h1 className="mb-4">Admin Panel</h1>

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-4"
      >
        <Tab eventKey="dashboard" title="Admin Dashboard">
          <AdminDashboard />
        </Tab>
        <Tab eventKey="data" title="Data Management">
          <Card>
            <Card.Header>
              <h4>Question Database Management</h4>
              <p className="text-muted mb-0">
                View, edit, and delete questions from the database
              </p>
            </Card.Header>
            <Card.Body>
              <DataTable isAdmin={true} />
            </Card.Body>
          </Card>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default AdminDataView;
